import { render, staticRenderFns } from "./editSmallClass.vue?vue&type=template&id=a39b2b8c&scoped=true&"
import script from "./editSmallClass.vue?vue&type=script&lang=js&"
export * from "./editSmallClass.vue?vue&type=script&lang=js&"
import style0 from "./editSmallClass.vue?vue&type=style&index=0&id=a39b2b8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39b2b8c",
  null
  
)

export default component.exports